import React, { useEffect, useReducer, useState } from 'react';
import { VALIDATION_STATES } from '../../utils/constants';
import FirstName from '../Fields/FirstName';
import LastName from '../Fields/LastName';
import CreditCardNumber from '../Fields/CreditCardNumber';
import CreditCardExpMonth from '../Fields/CreditCardExpMonth';
import CreditCardExpYear from '../Fields/CreditCardExpYear';
import CreditCardCvv from '../Fields/CreditCardCvv';
import { GridContainer } from '@parchment/atoms';
const noop = () => undefined;
const BLANK_CREDIT_CARD = {
  verified: false,
  firstName: '',
  lastName: '',
  creditCardNumber: '',
  creditCardExpMonth: '',
  creditCardExpYear: '',
  creditCardCvv: ''
};
const INITIAL_VALIDATION_STATE = {
  firstName: {
    state: VALIDATION_STATES.neutral
  },
  lastName: {
    state: VALIDATION_STATES.neutral
  },
  creditCardNumber: {
    state: VALIDATION_STATES.neutral
  },
  creditCardExpMonth: {
    state: VALIDATION_STATES.neutral
  },
  creditCardExpYear: {
    state: VALIDATION_STATES.neutral
  },
  creditCardCvv: {
    state: VALIDATION_STATES.neutral
  }
};
const VALIDATION_STATE_REDUCER = (prevState, updatedProperty) => ({
  ...prevState,
  ...updatedProperty
});
export default function CreditCardGrid(_ref) {
  let {
    creditCard = BLANK_CREDIT_CARD,
    required = false,
    disabled = false,
    onChange = noop,
    onValidate = noop
  } = _ref;
  const wrapper = /*#__PURE__*/React.createRef();
  const [, setAutoSelectVerified] = useState(false);
  const [validationStates, setValidationStates] = useReducer(VALIDATION_STATE_REDUCER, INITIAL_VALIDATION_STATE);
  const {
    firstName = '',
    lastName = '',
    creditCardNumber = '',
    creditCardExpMonth = '',
    creditCardExpYear = '',
    creditCardCvv = ''
  } = creditCard;
  useEffect(() => {
    const states = Object.values(validationStates).map(field => field.state);
    if (states.indexOf(VALIDATION_STATES.error) >= 0) {
      return onValidate(VALIDATION_STATES.error);
    } else if (states.indexOf(VALIDATION_STATES.neutral) >= 0) {
      return onValidate(VALIDATION_STATES.neutral);
    } else if (states.indexOf(VALIDATION_STATES.pending) >= 0) {
      return onValidate(VALIDATION_STATES.pending);
    } else if (states.indexOf(VALIDATION_STATES.success) >= 0) {
      return onValidate(VALIDATION_STATES.success);
    }
  }, [validationStates]);
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapper
  }, /*#__PURE__*/React.createElement(GridContainer, {
    "data-foo": "bar"
  }, /*#__PURE__*/React.createElement(FirstName, {
    value: firstName,
    disabled: disabled,
    required: required,
    internalLabel: true,
    onChange: value => onChange({
      ...creditCard,
      verified: false,
      firstName: value
    }, 'firstName'),
    onValidate: validationState => setValidationStates({
      firstName: {
        state: validationState
      }
    }),
    onFocus: () => setAutoSelectVerified(false),
    onBlur: () => setTimeout(() => setAutoSelectVerified(true), 300),
    width: "50%"
  }), /*#__PURE__*/React.createElement(LastName, {
    value: lastName,
    disabled: disabled,
    internalLabel: true,
    onChange: value => onChange({
      ...creditCard,
      verified: false,
      lastName: value
    }, 'lastName'),
    onValidate: validationState => setValidationStates({
      lastName: {
        state: validationState
      }
    }),
    onFocus: () => setAutoSelectVerified(false),
    onBlur: () => setTimeout(() => setAutoSelectVerified(true), 300),
    width: "50%"
  }), /*#__PURE__*/React.createElement(CreditCardNumber, {
    value: creditCardNumber,
    disabled: disabled,
    internalLabel: true,
    required: required,
    onChange: value => onChange({
      ...creditCard,
      verified: false,
      creditCardNumber: value
    }, 'creditCardNumber'),
    onValidate: validationState => setValidationStates({
      creditCardNumber: {
        state: validationState
      }
    }),
    onFocus: () => setAutoSelectVerified(false),
    onBlur: () => setTimeout(() => setAutoSelectVerified(true), 300),
    width: "100%"
  }), /*#__PURE__*/React.createElement(CreditCardExpMonth, {
    value: creditCardExpMonth,
    disabled: disabled,
    required: required,
    onChange: value => onChange({
      ...creditCard,
      verified: false,
      creditCardExpMonth: value
    }, 'creditCardExpMonth'),
    onValidate: validationState => setValidationStates({
      creditCardExpMonth: {
        state: validationState
      }
    }),
    onFocus: () => setAutoSelectVerified(false),
    onBlur: () => setTimeout(() => setAutoSelectVerified(true), 300)
  }), /*#__PURE__*/React.createElement(CreditCardExpYear, {
    value: creditCardExpYear,
    disabled: disabled,
    required: required,
    onChange: value => onChange({
      ...creditCard,
      verified: false,
      creditCardExpYear: value
    }, 'creditCardExpYear'),
    onValidate: validationState => setValidationStates({
      creditCardExpYear: {
        state: validationState
      }
    }),
    onFocus: () => setAutoSelectVerified(false),
    onBlur: () => setTimeout(() => setAutoSelectVerified(true), 300)
  }), /*#__PURE__*/React.createElement(CreditCardCvv, {
    value: creditCardCvv,
    disabled: disabled,
    internalLabel: true,
    required: required,
    onChange: value => onChange({
      ...creditCard,
      verified: false,
      creditCardCvv: value
    }, 'creditCardCvv'),
    onValidate: validationState => setValidationStates({
      creditCardCvv: {
        state: validationState
      }
    }),
    onFocus: () => setAutoSelectVerified(false),
    onBlur: () => setTimeout(() => setAutoSelectVerified(true), 300)
  })));
}